// native.js — Brücke zur ViaCamp-App (Flutter-WebView, mobile/lib/screens/webview_screen.dart): Teilen, Pull-to-refresh.
// shareData(): Ergebnis 'shared' | 'cancelled' | 'unsupported' — bei 'unsupported' zeigt der Aufrufer seine
// Ausweichlösung (Link kopieren). Die Android-WebView kennt navigator.share nicht; die App bietet dafür 'share'.
// Ältere App-Versionen kennen 'pullToRefresh' nicht — der Aufruf bleibt dann wirkungslos.
export function bridge(win = typeof window !== 'undefined' ? window : null) {
  const b = win && win.flutter_inappwebview;
  return b && typeof b.callHandler === 'function' ? b : null;
}

export const canShare = (win = typeof window !== 'undefined' ? window : null) => !!(bridge(win) || (win && win.navigator && win.navigator.share));

export async function shareData(data, win = typeof window !== 'undefined' ? window : null) {
  const b = bridge(win);
  if (b) {
    try { const r = await b.callHandler('share', data); if (r && r.ok) return 'shared'; } catch { /* Brücke kaputt → Web-Weg */ }
  }
  if (win && win.navigator && win.navigator.share) {
    try { await win.navigator.share(data); return 'shared'; } catch (e) { if (e && e.name === 'AbortError') return 'cancelled'; }
  }
  return 'unsupported';
}

/** Pull-to-refresh der App ab-/anschalten (Vollbild-Karte). Im Browser ohne Wirkung. */
export function nativePullToRefresh(enabled, win = typeof window !== 'undefined' ? window : null) {
  const b = bridge(win);
  if (!b) return false;
  try { Promise.resolve(b.callHandler('pullToRefresh', { enabled: !!enabled })).catch(() => {}); } catch { return false; }
  return true;
}
